module.exports = __webpack_public_path__ + "img/tipsMask.bf456cb8.png";